
<lib-chip-button #chipButton [ngClass]="{'d-none': loading, 'd-flex': !loading}" [hasCarretSuffix]="true" [menuTrigger]="isMobile ? null : menuTrigger"
    (click)="TimeSelectClicked()">
    <lib-icon class="color-brand" [icon]="Icon.Common.Time"></lib-icon>
    <p class="typography-label-large px-1 base-300">
        <ng-container *ngIf="startTimeISO && startTimeISO != endTimeISO">
            {{startTimeISO | formatTime:'short'}} -
        </ng-container>
        <ng-container *ngIf="!startTimeISO || !endTimeISO" i18n="@@CommonAnyTime">
            Any Time
        </ng-container>
        <!-- eslint-disable-next-line -->
        <ng-container *ngIf="!startTimeISO && endTimeISO">-</ng-container>
        <ng-container *ngIf="endTimeISO">
            {{endTimeISO | formatTime:'short'}}
        </ng-container>
    </p>
</lib-chip-button>

<mat-menu #menuTrigger="matMenu" yPosition="below" class="chip-date-range-select" [overlapTrigger]="false" (closed)="PanelClosed()"
	backdropClass="mat-menu-custom-backdrop">
    <lib-chip-time-range-picker-panel
        [startTime]="startSBTime"
        [endTime]="endSBTime"
        [labels]="labels"
        (timeChange)="TimeChanged($event)"
        (closePanel)="ClosePanel()">
        <ng-container title>
            <ng-content select="[title]"></ng-content>
        </ng-container>
    </lib-chip-time-range-picker-panel>
</mat-menu>
